const initialState = {
  tradLanguages: ['en'],
};

function reducerReferential(state = initialState, action: any) {
  switch (action.type) {
    default:
      return state;
  }
}
export default reducerReferential;
